import { mapGetters } from 'vuex'
import Vue from 'vue'
Vue.mixin({
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'loggedInUser',
      'menus',
      'userAuthors',
      'allLocales'
    ])
  },
  mounted() {
    this.$eventHub.$on('refreshAll', this.refreshAll)
  },
  beforeDestroy() {
    this.$eventHub.$off('refreshAll', this.refreshAll)
  },
  methods: {
    checkLogin() {
      // http://localhost:3106/offline_meeting_ticket?tmpId=zOZXmJRfjQeMzUDAZ4wZhishXiU8RPAM
      if (
        this.$route.path === '/offline_meeting_ticket' &&
        this.$route.query.tmpId
      ) {
        return false
      }

      if (this.$route.path === '/calc' && this.$route.query.tid) {
        return false
      }

      if (!this.loggedInUser) {
        // this.toastErrorCode('common.notification.login_required')
        this.$router.push('/login')
        return false
      }
      return true
    },
    refreshAll() {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    getMenus() {
      if (this.$store.state.auth && this.$store.state.auth.user) {
        return this.$store.state.auth.user.menus
      }
      return this.$store.state.default_menus
    },
    isMenuLoaded() {
      if (this.$store.state.auth && this.$store.state.auth.user) {
        return !!this.$store.state.auth.user
      }
      return this.$store.state.default_menu_loaded
    },
    hasRole(role) {
      if (!this.loggedInUser) {
        return false
      }
      for (let i = 0; i < this.loggedInUser.siteRoles.length; i++) {
        if (
          this.loggedInUser.siteRoles[i].role &&
          this.loggedInUser.siteRoles[i].role.role === role
        ) {
          return true
        }
      }
      return false
    },
    getRoleNames() {
      if (!this.loggedInUser) {
        return ''
      }
      let roles = ''
      for (let i = 0; i < this.loggedInUser.siteRoles.length; i++) {
        const siteRole = this.loggedInUser.siteRoles[i]
        if (siteRole.role.role === 'role_anonymous') {
          continue
        }
        if (!siteRole.site) {
          continue
        }
        if (siteRole.site.id !== process.env.siteId) {
          continue
        }
        if (siteRole.role && siteRole.role.role) {
          if (roles) {
            roles += ', '
          }
          roles += this.$t('role.nm.' + siteRole.role.role)
        }
      }
      return roles
    },
    getMenuAlias() {
      let menuAlias = $(this.$el)
        .closest('[menu-alias]')
        .attr('menu-alias')
      if (!menuAlias) {
        menuAlias = this.$route.path
        if (menuAlias.indexOf('/') >= 0) {
          menuAlias = menuAlias.substring(menuAlias.lastIndexOf('/') + 1)
        }
      }
      return menuAlias
    },
    getMenuAliasQuery() {
      return 'menuAlias=' + this.getMenuAlias()
    },
    hasAuthority(authority) {
      if (this.dontCheckAuthor) {
        return true
      }
      if (!this.userAuthors) {
        return false
      }
      const menu = this.getMenuAlias()
      if (!menu) {
        return false
      }
      for (let i = 0; i < this.userAuthors.length; i++) {
        if (
          this.userAuthors[i].menuAlias === menu &&
          this.userAuthors[i].author === authority
        ) {
          return true
        }
      }
      return false
    }
  }
})
